import { Project } from 'assets/Projects';

// Helper function to load multiple images for a project
// Images should be named: project-slug-1.png, project-slug-2.png, etc.
const loadProjectImages = (
  projectDir: string,
  projectSlug: string,
  count: number = 3,
  type: string = 'png',
): string[] => {
  const images: string[] = [];
  for (let i = 1; i <= count; i += 1) {
    try {
      // eslint-disable-next-line max-len
      // eslint-disable-next-line global-require, import/no-dynamic-require, import/no-unresolved, @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
      const img = require(`assets/projects/${projectDir}/${projectSlug} (${i}).${type}`);
      images.push(img);
    } catch {
      // Image doesn't exist, skip it
    }
  }
  return images.length > 0 ? images : [];
};

// Helper function to load a video for a project
// Video should be named: video-name.mp4
const loadProjectVideo = (projectDir: string, videoName: string): string => {
  try {
    // eslint-disable-next-line max-len
    // eslint-disable-next-line global-require, import/no-dynamic-require, import/no-unresolved, @typescript-eslint/no-var-requires, @typescript-eslint/no-require-imports
    const video = require(`assets/projects/${projectDir}/${videoName}.mp4`);
    return video;
  } catch {
    // Video doesn't exist, return empty string
    return '';
  }
};

// Load images for each project
const adamFileManagementThumbnail = loadProjectImages('adam-file-management', 'thumbnail', 1);
const adamFileManagementDesktop = loadProjectImages('adam-file-management', 'adam-file-management-desktop', 7);
const adamFileManagementMobile = loadProjectImages('adam-file-management', 'adam-file-management-mobile', 7);

const assistMind = loadProjectImages('assistmind', 'thumbnail', 1);
const assistMindDesktop = loadProjectImages('assistmind', 'assistmind-desktop', 18);
const assistMindMobile = loadProjectImages('assistmind', 'assistmind-mobile', 16);

const aiAutomationWithNoLow = loadProjectImages('ai-automation-with-nocode-lowcode', 'thumbnail', 1, 'webp');
const aiVoiceAgentLQaAS = loadProjectImages('ai-automation-with-nocode-lowcode', 'ai-voice-agent-lead-qualifying-and-appointment-setting', 5);
const benefitsOfUsingN8NAndMake = loadProjectImages('ai-automation-with-nocode-lowcode', 'benefits-of-using-u8u-and-make', 4);
const automationForRecruitment = loadProjectImages('ai-automation-with-nocode-lowcode', 'automation-for-recruitment-processes', 5);
const automationCin7AndCloseCRM = loadProjectImages('ai-automation-with-nocode-lowcode', 'automation-cin7-and-closecrm', 3);
const automationMultiLocationDental = loadProjectImages('ai-automation-with-nocode-lowcode', 'automation-multilocation-dental', 3);

const aiBookingAgent = loadProjectImages('ai-booking-agent', 'thumbnail', 1, 'gif');
const aiBookingAgentDemo = loadProjectVideo('ai-booking-agent', 'demo');

const staticProjectsData: Project[] = [
  // {
  //   title: 'My Awesome GitHub Project',
  //   platform: 'github',
  //   description: 'This is a sample GitHub project.',
  //   language: 'JavaScript',
  //   createdAt: '2023-01-01T00:00:00Z',
  //   updatedAt: '2023-06-01T00:00:00Z',
  //   source: 'https://github.com/my-awesome-project',
  //   demo: 'https://my-awesome-project-demo.com',
  //   thumbnail: 'https://via.placeholder.com/150',
  //   interactions: {
  //     stars: 120,
  //     forks: 30,
  //     comments: 10,
  //   },
  // },
  // {
  //   title: 'Figma Design Prototype',
  //   platform: 'figma',
  //   description: 'A modern UI/UX design prototype.',
  //   language: 'Design',
  //   createdAt: '2023-02-01T00:00:00Z',
  //   updatedAt: '2023-05-01T00:00:00Z',
  //   source: 'https://www.figma.com/file/my-design-prototype',
  //   demo: '',
  //   thumbnail: 'https://via.placeholder.com/150',
  //   interactions: {
  //     likes: 200,
  //   },
  // },
  {
    title: 'An AI experience for file management and documentation',
    description: 'As a key member of the team, I worked on the design of ADAM (advanced document archiving management). This platform lets organisations and government agencies digitise documents and provides artificial intelligence for document enquiry and data extraction.',
    skills: ['React', 'TypeScript', 'Node.js', 'Python', 'PostgreSQL', 'Elasticsearch', 'AWS S3', 'Docker', 'Kubernetes', 'OpenAI API', 'LangChain', 'REST API', 'GraphQL', 'Redis', 'RabbitMQ', 'OCR/Tesseract', 'JWT Auth', 'AWS Lambda'],
    source: '',
    demo: '',
    platform: 'project',
    createdAt: '',
    updatedAt: '',
    interactions: {},
    featuredOrder: 1,
    thumbnail: adamFileManagementThumbnail[0],
    sections: [
      {
        title: 'What did we design?',
        blocks: [
          {
            type: 'text',
            content: 'We decided to take the folder system approach that they would use on their mobile phones and laptops. Something really easy to use.',
          },
          {
            type: 'images',
            urls: adamFileManagementDesktop.slice(0, 5), // First image
          },
          {
            type: 'mobile-images',
            urls: adamFileManagementMobile.slice(0, 4), // First image
          },
          {
            type: 'text',
            content: 'Our persona of older people as users will find it easier to use this system as they will find it familiar as it is used on their mobile phone and PC Windows folder system. They can format, arrange, search, upload and manage access to folders and documents. We also made sure our experience accounted for storage management, which would be best for the administrative process',
          },
        ],
      },
      {
        title: 'WHAT WE CAME UP WITH',
        blocks: [
          {
            type: 'text',
            content: `## ADAM IS ALIVE
ADAM is an AI entity that can read documentation and answer and cross reference documents, this will help government officials get information from a centralised database without having to go through long copious amount of documents.`,
          },
          {
            type: 'images',
            urls: adamFileManagementDesktop.slice(5, 7), // First image
          },
          {
            type: 'mobile-images',
            urls: adamFileManagementMobile.slice(4, 7), // First image
          },
        ],
      },
    ],
  },
  {
    title: 'AI Voice Agent Automation & Management SaaS Platform',
    description: 'An AI SaaS platform that lets businesses deploy intelligent AI voice agents to handle inbound/outbound calls for reception, lead capture, and customer service - complete with real-time analytics, calendar/CRM integrations, call flow builder, and admin oversight.',
    skills: ['Python', 'FastAPI', 'Next.js', 'TypeScript', 'Node.js', 'ExpressJS', 'PostgreSQL', 'Redis', 'TimescaleDB', 'React Query', 'Microservices Architecture', 'ChatGPT-4', 'Claude AI', 'Google Cloud Speech', 'Google Cloud TTS', 'ElevenLabs', 'WebRTC', 'Twilio Voice API', 'Stripe', 'Google Calendar API', 'Calendly API', 'GoHighLevel', 'SendGrid', 'JWT Auth', 'RBAC', 'Docker', 'AWS', 'CI/CD', 'GitHub Actions', 'REST API', 'WebSocket'],
    source: '',
    demo: '',
    platform: 'project',
    createdAt: '',
    updatedAt: '',
    interactions: {},
    featuredOrder: 2,
    thumbnail: assistMind[0],
    sections: [
      {
        title: 'What did we design?',
        blocks: [
          {
            type: 'text',
            content: 'AssistMind AI combines conversational AI and telephony automation into a seamless SaaS platform that lets any business deploy their own intelligent voice agent in minutes.',
          },
          {
            type: 'images',
            urls: assistMindDesktop.slice(0, 18), // First image
            captions: ['Set up AI Agent', 'AI Voice Agent Dashboard', 'Step 1. Lets Finalize Your AI Agent Setup', 'Step 2. Business Details & Availability', 'Step 3. Final Review & Launch', 'Call Flow Builder', 'Call log', 'Call Detail View', 'Call Detail View', 'Campaigns', 'Campaigns', 'Campaigns', 'Messages', 'Knowledge Base', 'Integrations', 'Settings', 'Settings', 'Settings'],
          },
          {
            type: 'mobile-images',
            urls: assistMindMobile.slice(0, 16), // First image
            captions: ['SignIn', 'SignUp', 'AI Voice Agent Dashboard', 'AI Voice Agent Dashboard', 'AI Voice Agent Dashboard', 'Step 1. Lets Finalize Your AI Agent Setup', 'Step 2. Business Details & Availability', 'Step 3. Final Review & Launch', 'Call Flow Builder', 'Call Flow Builder', 'Call Detail View', 'Call Detail View', 'Campaigns', 'Call Agent', 'Call Agent', 'Call Agent'],
          },
          {
            type: 'text',
            content: `**1. Onboarding Flow** : AI Agent intro, voice preview, account creation, Stripe checkout.
**2. AI Agent Setup Wizard** : 3-step wizard: Agent Profile → Business Details → Final Review & Launch.
**3. Voice Preview** : Real-time TTS integration for voice testing.
**4. Dashboard (Voice Agent)** : Tabs for Agent Profile, Performance, Controls, and Setup Checklist.
**5. AI Prompt Customization** : Role-specific prompt generation (Receptionist / Appointment Booker / Lead Qualifier).
**6. Calendar & CRM Integration** : Google, Calendly, GoHighLevel for bookings.
**7. Telephony Integration** : Twilio for live inbound/outbound calls, call recording, and transcription.
**8. Knowledge Base Upload** : PDF/DOCX/CSV upload to train the agent.`,
          },
        ],
      },
      {
        title: 'Built With',
        blocks: [
          {
            type: 'text',
            content: `## **Frontend**

* **Framework:** Next.js 14 + TypeScript
* **UI:** Tailwind CSS, Framer Motion (animations), React Hook Form
* **State Management:** React Query
* **Charts:** Recharts for analytics

## **Backend**

* **Language/Runtime:** Node.js + Express
* **Architecture:** Microservices (Auth, Agent, Calls, Billing, Analytics, Notification)
* **Database:** PostgreSQL + Redis
* **Queue / Cache:** Redis
* **Analytics DB:** TimescaleDB / InfluxDB

## **AI / Voice Layer**

* **LLMs:** GPT-4 / Claude
* **Speech-to-Text:** Google Cloud Speech
* **Text-to-Speech:** Google Cloud TTS / ElevenLabs
* **Voice Pipeline:** STT → LLM → TTS via WebRTC

## **Integrations**

* **Payments:** Stripe (trials, billing, invoices)
* **Telephony:** Twilio Voice API
* **Calendar:** Google Calendar, Calendly, GoHighLevel
* **Email/SMS:** SendGrid, Twilio SMS

## **Infrastructure**

* Dockerized microservices
* Deployed on AWS / GCP with auto-scaling
* SSL, JWT Auth, RBAC
* CI/CD (GitHub Actions)`,
          },
        ],
      },
      {
        title: 'My Role',
        blocks: [
          {
            type: 'text',
            content: `## **I built the AI Processing Engine including:**
- Integrated Speech-to-Text (Google Cloud Speech/Azure)
- Connected LLMs (GPT-4/Claude) with dynamic prompt generation
- Implemented Text-to-Speech pipeline
- Built conversation state management system
- Created the prompt generation engine
            
## **And Contributed 7 Microservices:**

- **User Management Service** - Authentication, JWT tokens, role-based access control
- **Agent Configuration Service** - AI agent setup, voice settings, business rules
- **Call Processing Service** - Real-time call handling orchestration
- **Analytics Service** - Metrics collection, trend analysis, real-time dashboards
- **Notification Service** - Email (SendGrid), SMS (Twilio), push notifications
- **Billing Service** - Stripe subscription management, webhooks, trial logic
- **Integration Service** - Google Business Profile, Calendar APIs, CRM connections

## **Database Architecture is desinged like below**
- Designed PostgreSQL schemas for users, agents, subscriptions
- Implemented TimescaleDB for analytics
- Set up Redis for caching and session management
- Optimized queries and created read replicas`,
          },
        ],
      },
    ],
  },
  {
    title: 'AI Booking Assistant Demo for Dental Clinics',
    description: 'This Demo is AI dental receptionist that autonomously handles appointment booking, rescheduling, and cancellations 24/7 through natural conversation.',
    skills: ['Python', 'FastAPI', 'OpenAI Agents SDK', 'Groq (Llama 3.3 70B)', 'Supabase', 'Redis', 'Supabase JWT', 'Google Calendar API', 'Brevo Email API', 'Chainlit'],
    source: '',
    demo: '',
    platform: 'project',
    createdAt: '',
    updatedAt: '',
    interactions: {},
    featuredOrder: 4,
    thumbnail: aiBookingAgent[0],
    sections: [
      {
        title: 'Multi-Agent Architecture',
        blocks: [
          {
            type: 'text',
            content: `
Three specialized agents work together:

1. **Receptionist Agent** - Greets patients, answers general questions, routes to specialists
2. **Scheduler Agent** - Books/reschedules appointments, checks availability, sends confirmations
3. **Canceling Agent** - Handles cancellations, sends confirmation emails

Agents seamlessly hand off conversations without the user noticing.`,
          },
          {
            type: 'video',
            url: aiBookingAgentDemo, // First image
          },
        ],
      },
      {
        title: 'Key Features',
        blocks: [
          {
            type: 'text',
            content: `
✓ Real-time streaming responses (ChatGPT-like)
✓ Automatic Google Calendar integration
✓ Professional HTML email notifications
✓ Timezone-aware scheduling (interprets "2 PM" as local time, not UTC)
✓ Duplicate appointment prevention
✓ Secure (JWT auth, Row Level Security, email validation)
✓ Stateful conversations (persists across refreshes)
✓ Easy customization (one JSON file for clinic details)

## Critical Features

**1. Golden Rule of Confirmation:**
Always repeat full appointment details back to user before booking
> "Just to confirm, I'm booking a Teeth Whitening on Wednesday, October 8 at 2:00 PM EST with Dr. Emily Carter. Shall I proceed?"

**2. Timezone Handling:**
All times are in clinic timezone (America/New_York)
> User says "2 PM" → System interprets as 2 PM EST, NOT UTC
> Prevents common scheduling errors

**3. Email Validation:**
Only accepts trusted domains
> gmail.com, yahoo.com, outlook.com, hotmail.com, icloud.com, protonmail.com
> Rejects fake/disposable emails

**4. Duplicate Prevention:**
Before creating appointment
> Checks database for existing appointment
> Matches: patient email, doctor email, service type, time (±1 minute)
> If found: Returns existing appointment instead of creating duplicate`,
          },
        ],
      },
    ],
  },
  {
    title: 'n8n & Make.com Experience for Business Automation & CRM',
    description: 'Designed and implemented end-to-end business automation solutions across multiple industries including healthcare, recruitment, and e-commerce. Specialized in integrating disparate systems through no-code/low-code platforms, custom API development, and AI voice agents to eliminate manual processes and improve operational efficiency by 60-80%. Built scalable workflows handling thousands of daily transactions across multi-location businesses.',
    skills: ['n8n', 'Make.com', 'JavaScript', 'Node.js', 'GoHighLevel', 'Typeform', 'Pipedrive CRM', 'Close CRM', 'Voice AI Agents', 'Retell AI', 'Vapi AI', 'Twilio SMS', 'Airtable', 'Cin7', 'Dentally', 'Acuity Scheduling', 'Breezy HR', 'Indeed API', 'Google Development Toolkit', 'Workflow Automation', 'API Integration', 'Custom Scripting', 'Business Process Automation'],
    source: '',
    demo: '',
    platform: 'project',
    createdAt: '',
    updatedAt: '',
    interactions: {},
    featuredOrder: 3,
    thumbnail: aiAutomationWithNoLow[0],
    sections: [
      {
        title: 'Key Benefits of Using n8n and Make.com for business automation',
        blocks: [
          {
            type: 'text',
            content: 'While both n8n and Make.com are robust tools for workflow automation, they serve different user groups based on their unique features and approaches. n8n stands out as a highly customizable, open-source platform, making it a top choice for developers and technically skilled users who require tailored solutions.',
          },
          {
            type: 'images',
            urls: benefitsOfUsingN8NAndMake.slice(0, 4), // First image
          },
          {
            type: 'text',
            content: `- Improved workflow efficiency: Both platforms allow for streamlining administrative tasks, reducing manual work and saving time for healthcare providers.
- Cost reduction: Automation can help lower operational costs by reducing the need for manual data entry and processing.
- Enhanced patient engagement: These tools can automate patient communication, appointment reminders, and follow-ups, improving overall patient experience.
- Data-driven decision making: By integrating with various healthcare systems, these platforms enable better data analysis and insights for informed decision-making.
- Flexibility and customization: n8n offers highly customizable workflows, allowing healthcare organizations to create tailored solutions for their specific needs.
- Integration capabilities: Both tools can integrate with Electronic Health Records (EHR) systems and other healthcare-specific applications.
- Scalability: Make.com's cloud-based infrastructure allows for easy scaling of automations, while n8n offers unlimited tasks on self-hosted servers.
- Privacy and security: n8n provides self-hosting options, giving healthcare organizations greater control over sensitive patient data.
- Error handling and reliability: Both platforms offer built-in error handling and retry mechanisms, ensuring the reliability of critical healthcare workflows.
- Compliance: The ability to customize and control data flows can help healthcare organizations maintain compliance with regulations like HIPAA.`,
          },
        ],
      },
      {
        title: 'What did I build?',
        blocks: [
          {
            type: 'text',
            content: `# **AI Voice Agent Lead Qualifying and Appointment Setting for Car Dealership**
A car dealership wanted to improve sales rep efficiency by filtering leads generated through Facebook ads.
I implemented a voice agent to call leads within minutes of sign-up. It asked qualifying questions and forwarded only qualified leads to a sales manager.`,
          },
          {
            type: 'images',
            urls: aiVoiceAgentLQaAS.slice(0, 5), // First image
          },
          {
            type: 'text',
            content: 'As the result The voice agent filtered out 32% of unqualified leads. Sales reps spoke only with high-potential prospects. The impact on closing rates is currently being monitored.',
          },
          {
            type: 'divider',
          },
          {
            type: 'text',
            content: `# **Automation development for Recruitment Processes**
The client was a US-based recruiting company specializing in healthcare professionals.
They required a flexible and adaptable system to manage their complex recruitment processes.
I built multiple workflows with Make.com and implemented powerful scripts in Airtable to create a seamless, 100% automated recruiting process.`,
          },
          {
            type: 'images',
            urls: automationForRecruitment.slice(0, 5), // First image
          },
          {
            type: 'divider',
          },
          {
            type: 'text',
            content: `# **Automation development between Cin7 and Close CRM**
Automation implements email marketing using users' emails in Close CRM as a follow-up action when customer data changes in Cin7`,
          },
          {
            type: 'images',
            urls: automationCin7AndCloseCRM.slice(0, 3), // First image
          },
          {
            type: 'divider',
          },
          {
            type: 'text',
            content: `# **Multi-Location Dental Practice Automation**
I built a centralized, multi-practice dental automations using Make.com to seamlessly connect scheduling, communication, and practice management systems across diverse clinics. The platform integrates tools like Acuity Scheduling, Dentally, Aircall, and custom CRMs to automate appointment booking, real-time staff availability checks, insurance verification, and patient confirmations—all while supporting multiple locations under a unified “zero-platform” architecture. By orchestrating webhooks, AI voice agents, and cross-system data syncs, it eliminates manual coordination, reduces no-shows, and scales operations across independent dental practices.`,
          },
          {
            type: 'images',
            urls: automationMultiLocationDental.slice(0, 3), // First image
          },
        ],
      },
    ],
  },
  {
    title: 'AI-Powered Real Estate Property Search System',
    description: 'Estate-Assistant is an intelligent conversational AI application that helps users discover real estate properties in France based on their budget, location preferences, size requirements, and desired amenities. The system leverages OpenAI\'s GPT-4 Assistant API with function calling capabilities to provide personalized property recommendations from a curated dataset of 169 real estate listings.',
    skills: ['Python', 'OpenAI API', 'GPT-4', 'AI Function Calling', 'Natural Language Processing', 'Conversational AI', 'Pandas', 'Data Processing', 'Excel Integration', 'Real Estate Tech', 'Chatbot Development'],
    source: 'https://github.com/royxlab/Real-Estate-Assistant',
    demo: '',
    platform: 'project',
    createdAt: '',
    updatedAt: '',
    interactions: {},
    featuredOrder: 0,
    thumbnail: '',
    sections: [
      {
        title: 'Key Features',
        blocks: [
          {
            type: 'text',
            content: `## Intelligent Conversational Interface
- Natural language interaction for property searches
- Budget-based filtering with intelligent 20% buffer for flexibility
- Multi-criteria search (budget, property type, size, amenities)
- Contextual recommendations through OpenAI's Assistant API

## Advanced Property Filtering
- Budget-aware search: Finds properties within user's budget ± 20%
- Property type filtering: Focused on apartments ("Appartement")
- Size constraints: Optional minimum square meter requirements
- Amenity matching: Filter by specific property features
- Smart ranking: Returns top 3-5 most relevant properties`,
          },
        ],
      },
      {
        title: 'System Components',
        blocks: [
          {
            type: 'text',
            content: `## 1. AI Assistant Engine
- Assistant Management: Automatically creates or retrieves persistent assistant "Ottavio"
- Function Calling: GPT-4 triggers filter_properties function with extracted parameters
- Thread Management: Maintains conversation context across interactions
- Error Handling: Robust error recovery and user-friendly error messages
## 2. Data Processing Pipeline
- Data Loading: Excel file ingestion with automatic data type conversion
- Data Cleaning: Removes whitespace from price fields, handles missing values
- Filtering Logic: Multi-dimensional filtering based on user criteria
- Response Formatting: Structured output with property titles, prices, sizes, and URLs
## 3. Dataset
- 169 properties stored in Flat range search.xlsx
- Rich metadata: URL, title, type, location, price, size, amenities, energy ratings
- JSON backup: DBTest-AssistantAI.json for data portability`,
          },
        ],
      },
      {
        title: 'Use Cases',
        blocks: [
          {
            type: 'text',
            content: `- First-time homebuyers: Budget-conscious property search
- Real estate agents: Quick property matching for clients
- Property investors: Market research and opportunity identification
- Relocation assistance: Finding suitable properties in new cities
`,
          },
        ],
      },
    ],
  },
  {
    title: 'AI Book Creator',
    description: 'This is a web app that leverages AI to generate complete books. It showcases the practical application of LLMs in creative content generation and also how AI can be integrated into products to automate complex creative workflows. Users input creative parameters through an intuitive form interface, and the system produces a fully formed narrative with chapters, character development, and cohesive storytelling -- all within minutes.',
    skills: ['React', 'Redux', 'Node.js', 'PHP', 'Payment Processing', 'Real-time Communication', 'Marketplace Development', 'API Integration'],
    source: 'https://github.com/royxlab/AI-Book-Creator-Tool',
    demo: '',
    platform: 'project',
    createdAt: '',
    updatedAt: '',
    interactions: {},
    featuredOrder: 0,
    thumbnail: '',
    sections: [
      {
        title: 'System Design',
        blocks: [
          {
            type: 'text',
            content: `## Presentation Layer
- React client component with controlled form state
- Real-time loading states with skeleton UI
- Responsive two-column layout (form + preview)
- Dynamic field rendering with validation-ready inputs
## API Layer
- RESTful POST endpoint for book generation
- Structured prompt engineering for consistent AI outputs
- Comprehensive error handling and JSON response formatting
- Environment-based API key management
## AI Integration
- Custom prompt template that transforms user inputs into detailed creative briefs
- System-level instructions for narrative consistency, character development, and world-building
- GPT-4o model selection for high-quality, coherent long-form content`,
          },
        ],
      },
      {
        title: 'Key Technical Features',
        blocks: [
          {
            type: 'text',
            content: `## 1. Intelligent Prompt Engineering
- The application constructs sophisticated prompts from 13+ user-customizable parameters:
- Structural (title, genre, chapters)
- Creative (tone, style, theme)
- Contextual (setting, plot, characters)
- Meta (audience, purpose, language)
## 2. User Experience Design
- Progressive disclosure: Form collects comprehensive details without overwhelming users
- Loading states: Animated skeleton screens during AI generation
- Instant preview: Real-time display of generated content
- Accessibility: Semantic HTML, ARIA-compliant form controls
## 3. Scalable Architecture
- App Router: Leverages Next.js 14's latest routing conventions
- Server Components: Optimized initial page loads
- API Routes: Isolated backend logic for easy testing and maintenance
- Environment configuration: Secure credential management via .env
## 4. Production-Ready Code
- TypeScript strict mode enforcement
- ESLint configuration for code quality
- Tailwind with PostCSS for optimized CSS`,
          },
        ],
      },
      {
        title: 'Use Cases',
        blocks: [
          {
            type: 'text',
            content: `- Creative Writing Aid: Rapid prototyping of story concepts
- Content Marketing: Automated generation of narrative-style marketing materials
- Education: Demonstrating AI-assisted creative workflows
- Research: Exploring LLM capabilities in long-form content generation
`,
          },
        ],
      },
    ],
  },
];

export default async function getProjects() {
  // Return the static data instead of making an API call
  return staticProjectsData;
}
